export default __webpack_public_path__ + "static/media/Outcome_of_Board_Meeting_Postal.c39ea525.pdf";